export interface BidClsConsor {
    bidNo: string;
    bidModSeq: string;
    bidCls: string;
    bidClsNm: string;
    bidClsDtlDesc: string;
    guaranteeAmount: string;
    guaranteeAmountCurr: string;
    budgetAmt: string;
    budgetAmtCurr: string;
    publicYn: string;
    ardExistConsor: number;
    ardExistConsorMem: number;
    approvedMem: number;
    approvedChef: number;
    approved: number;
    idCls: number;
    idParent: number;
}

export class EPConsor {
    bidNo: string;
    bidModSeq: string;
    bidCls: string = '';
    bizRegNo: string = '';
    listBidCls: any;
    sequence: any;
    memRegNo: string = '';
    reprRegNo: string = '';
    table: string = '';
    approveYn?: string;
    isReprYn?: string;
}
